import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { Outlet, useNavigate } from "react-router-dom";
import { useHomeOutletContext } from "../../layout/useHomeOutletContext.ts";

export default function MyCoursesLayout() {
  const { isSidebarExpandable, onSidebarToggle } = useHomeOutletContext();
  const brand = useBrandLoaderData();
  const navigate = useNavigate();

  if (!brand.MyCourses.enabled) {
    navigate("/");
  }

  return <Outlet context={{ isSidebarExpandable, onSidebarToggle }} />;
}
